import {NoteModel} from "./note.model";
import {AddressModel} from "../components/modal/add-address-to-model/address.model";
import {BaseModel} from "./base.model";
import {Distributor} from "./distributor.model";

export class MeasuringPoint implements BaseModel {

  id: number;
  name: string = '';
  description: string = '';
  latitude: number = 47.4725155;
  longitude: number = 19.059474;
  threshold: number = 10;
  attachment: any = null;
  attachments: any[];
  timezone: string = 'Europe/Budapest';
  note?: NoteModel;
  address: AddressModel = new AddressModel();
  distributor?: Distributor;
  distributorId?: number;

  constructor(obj: any = undefined) {
    if (obj) {
      try {
        this.id = obj.id;
        this.name = obj.name;
        this.description = obj.description;
        this.latitude = obj.latitude;
        this.longitude = obj.longitude;
        this.threshold = obj.threshold;
        this.attachment = obj.attachment;
        this.attachments = obj.attachments;
        this.timezone = obj.timezone;
        this.note = obj.note;
        if (obj.address.id) {
          delete obj.address.id;
        }
        this.address = obj.address;
        this.distributor = obj.distributor;
        this.distributorId = obj.distributorId;
      } catch {

      }
    }
  }

  public clone(): MeasuringPoint {
    const clone = new MeasuringPoint();

    clone.name = this.name;
    clone.description = this.description;
    clone.latitude = this.latitude;
    clone.longitude = this.longitude;
    clone.threshold = this.threshold;
    clone.attachment = this.attachment;
    clone.attachments = this.attachments;
    clone.timezone = this.timezone;
    clone.note = this.note;
    clone.address = this.address;
    clone.distributor = this.distributor;
    clone.distributorId = this.distributorId ? this.distributorId : this.distributor?.id;

    return clone;
  }
}

